import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import { HR_EMPLOYEE_NOTIFICATIONS_LATEST } from '../employeeNotificationEndpoints'
import { EMPLOYEE_NOTIFICATIONS_LATEST_QUERY_KEY } from '../employeeNotificationQueryKeys'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { LatestEmployeeNotificationDto } from '@/modules/Notification/types/api/employeeNotification'

export function fetchLatestEmployeeNotifications(): Promise<
  LatestEmployeeNotificationDto[]
> {
  return axiosInstance
    .get<LatestEmployeeNotificationDto[]>(HR_EMPLOYEE_NOTIFICATIONS_LATEST)
    .then((response) => response.data)
}

export function useLatestEmployeeNotificationsQuery(
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchLatestEmployeeNotifications>>
    >,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery({
    queryKey: [EMPLOYEE_NOTIFICATIONS_LATEST_QUERY_KEY],
    queryFn: fetchLatestEmployeeNotifications,
    ...options,
  })
}
